<template lang="pug">
  div
    .pricing-header.px-3.py-3.pt-md-6.pb-md-5.pb-md-4.mx-auto.text-center
      h1.display-4 Select Membership
    ValidationObserver(ref="Validation" slim)
      ValidationProvider(ref="Provider" name="membership", rules="required" v-slot="{errors}" slim :customMessages="{required: 'Please select a membership.'}")
        .row
          .col-12.pb-3(v-for="(mem, index) in memberships", :key="index", :class="{'border-danger': errors.length > 0}")
            .card
              .card-header
                h4.my-0.font-weight-normal.text-center {{mem.name}}
              .card-body
                h1.card-title.pricing-card-title.text-center PHP {{mem.total_fee}}
                //- h1.card-title.pricing-card-title $0 <small class="text-muted">/ ml</small>
              ul.list-group.list-group-flush(v-if="mem.service_fees.length > 0")
                li.list-group-item.d-flex.justify-content-between(v-for="(ser, i) in mem.service_fees", :key="i")
                  span {{ser.name}}
                  span PHP {{ser.price}}
              ul.group.list-group-flush(v-else)
                li.list-group-item.text-center
                  span: i ( No services )
              .card-body
                button.btn.btn-lg.btn-block(type="button", :class="{'btn-primary': value==mem.id, 'btn-outline-primary': !value || value!=mem.id}" @click.prevent="select(mem)") Be a member
      //- ValidationProvider(name="membership", rules="required" v-slot="{errors}" slim :customMessages="{required: 'Please read and confirm the agreement.'}")
        .
        //- div
          .custom-control.custom-checkbox
            input.custom-control-input#confirmatory(type="checkbox" v-model="isChecked")
            label.custom-control-label(:class="{'text-danger': errors.length}" for="confirmatory") I understand that my personal information is protected by RA 10173, the Data Privacy Act of 2012, and that I am required to provide truthful and correct information.
          p.text-danger(v-if="errors.length") {{errors[0]}}
</template>

<style scoped=""></style>

<script>
import { ref, reactive, watch } from '@vue/composition-api';

export default {
  name: 'SelectMembership',
  props: {
    memberships: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
  },
  emits: ['next', 'input'],

  setup(props, { emit }) {
    const Validation = ref(null);
    const Provider = ref(null);
    // const isChecked = ref(props.value)

    const next = () => {
      emit('next');
    };
    /**
     * [description]
     * @return {[type]} [description]
     */
    const validate = () => {
      // emit('input', isChecked.value)
      return Validation.value.validate().then((success) => {
        if (success) {
          return Promise.resolve(success);
        }
        return Promise.reject(success);
      });
    };
    const select = (mem) => {
      emit('input', mem.id);
      // Provider.value.validate(mem.id)
    };
    watch(
      () => props.value,
      (newVal, prevVal) => {
        // console.log(newVal)
        Provider.value.validate(newVal);
      }
    );
    return {
      Validation,
      Provider,
      next,
      validate,
      select,
      // isChecked
    };
  },
};
</script>
